export default [
    {
        path: '/ypIndex', // 疫情退改申请首页
        component: resolve => require(['@/pages/weixinH5/apply/ypIndex'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/ypApply', // 疫情退改申请
        component: resolve => require(['@/pages/weixinH5/apply/ypApply'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/ypList', // 疫情退改申请记录
        component: resolve => require(['@/pages/weixinH5/apply/ypList'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/ypDetail', // 详情
        component: resolve => require(['@/pages/weixinH5/apply/ypDetail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/groundJump', // 跳转
        component: resolve => require(['@/pages/weixinH5/apply/groundJump'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/getPsyInfo', // 杭州到港旅客信息收集表
        component: resolve => require(['@/pages/weixinH5/apply/getPsyInfo'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/psyInfoSuc', // 旅客信息收集表提交成功页面
        component: resolve => require(['@/pages/weixinH5/apply/psyInfoSuc'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/groundJumpNew', // 跳转
        component: resolve => require(['@/pages/weixinH5/apply/groundJumpNew'], resolve),
        meta: { title: "长龙航空" }
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/apply.js